import focusLock from "dom-focus-lock"

type Props = {
  videoId: string
  triggerSelector: string
  modalSelector: string
  videoSelector: string
  closeSelector: string
}

export default function videoModal(
  el: HTMLElement,
  {
    videoId,
    triggerSelector,
    modalSelector,
    videoSelector,
    closeSelector,
  }: Props,
) {
  const triggerEl: HTMLButtonElement | null = el.querySelector(triggerSelector)
  const modalEl: HTMLElement | null = el.querySelector(modalSelector)
  const videoEl: HTMLElement | null = el.querySelector(videoSelector)
  const closeEl: HTMLButtonElement | null = el.querySelector(closeSelector)

  triggerEl?.addEventListener("click", function () {
    showModal(modalEl, videoId, videoEl)
  })

  closeEl?.addEventListener("click", function () {
    hideModal(modalEl, videoEl)
  })

  document.addEventListener("keyup", function (e) {
    if (27 === e.keyCode && "Escape" === e.key) {
      if (modalEl?.classList.contains("opacity-100")) {
        hideModal(modalEl, videoEl)
      }
    }
  })
}

function showModal(
  modalEl: HTMLElement | null,
  videoId: string,
  videoEl: HTMLElement | null,
) {
  modalEl?.classList.remove("opacity-0")
  modalEl?.classList.remove("pointer-events-none")
  modalEl?.classList.add("opacity-100")
  modalEl?.classList.add("pointer-events-all")
  focusLock.on(modalEl)
  let video: HTMLElement = document.createElement("iframe")
  video.setAttribute(
    "src",
    `//fast.wistia.net/embed/iframe/${videoId}?autoPlay=true`,
  )
  video.setAttribute("allowtransparency", "true")
  video.setAttribute("frameborder", "no")
  video.setAttribute("scrolling", "no")
  video.setAttribute("allowfullscreen", "true")
  video.setAttribute("width", "1240")
  video.setAttribute("height", "690")
  video.setAttribute("name", "wistia_embed")
  video.setAttribute("autoplay", "true")
  video.classList.add("wistia_embed")
  videoEl?.append(video)
}

function hideModal(modalEl: HTMLElement | null, videoEl: HTMLElement | null) {
  modalEl?.classList.remove("opacity-100")
  modalEl?.classList.remove("pointer-events-all")
  modalEl?.classList.add("opacity-0")
  modalEl?.classList.add("pointer-events-none")
  focusLock.off(modalEl)
  let video: HTMLIFrameElement | null | undefined =
    videoEl?.querySelector("iframe")
  if (video == null) {
    return
  }
  videoEl?.removeChild(video)
}
